// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"ac9cca47","252":"6d4a8ae1","402":"c890b113","578":"2d63d14b","580":"d2e81741","987":"0a791746"}[chunkId] + ".chunk.js";
};